// @flow
import I18n from '../../lib/i18n';
import type { Subscription } from 'digicel-kaizen-library';
import type { errorMapForOrderStateType } from '../PollingOrder/lib';

export type ManageLineActionType =
  | {|
      type: 'SUSPEND_LINE',
      payload: {|
        subscription: ?Subscription,
        errorMapForOrderState: errorMapForOrderStateType,
      |},
    |}
  | {|
      type: 'TERMINATE_LINE',
      payload: {|
        subscription: ?Subscription,
        errorMapForOrderState: errorMapForOrderStateType,
      |},
    |}
  | {|
      type: 'UNSUSPEND_LINE',
      payload: {|
        subscription?: ?Subscription,
        errorMapForOrderState: errorMapForOrderStateType,
      |},
    |}
  | {
      type: 'SWAP_SIM',
      payload: {|
        subscription: ?Subscription,
        errorMapForOrderState: errorMapForOrderStateType,
      |},
    };

export const suspendLine = (subscription: ?Subscription): ManageLineActionType => ({
  type: 'SUSPEND_LINE',
  payload: {
    subscription,
    errorMapForOrderState: {
      key: 'suspendSwapTerminateLine',
      type: {
        FAILED: {
          title: I18n.t('Dashboard.LostAndStolen.suspensionFailureTitle'),
          text: I18n.t('Dashboard.LostAndStolen.suspensionFailureText'),
        },
        IN_PROGRESS: {
          title: I18n.t('Dashboard.LostAndStolen.suspensionInProgressTitle'),
        },
      },
    },
  },
});

export const terminateLine = (subscription: ?Subscription): ManageLineActionType => ({
  type: 'TERMINATE_LINE',
  payload: {
    subscription,
    errorMapForOrderState: {
      key: 'suspendSwapTerminateLine',
      type: {
        FAILED: {
          title: I18n.t('Dashboard.LineTermination.terminationFailureTitle'),
          text: I18n.t('Dashboard.LineTermination.terminationFailureText'),
        },
        IN_PROGRESS: {
          title: I18n.t('Dashboard.LineTermination.terminationInProgressTitle'),
        },
      },
    },
  },
});

export const unsuspendLine = (subscription?: ?Subscription): ManageLineActionType => ({
  type: 'UNSUSPEND_LINE',
  payload: {
    subscription,
    errorMapForOrderState: {
      key: 'suspendSwapTerminateLine',
      type: {
        FAILED: {
          title: I18n.t('Dashboard.Unsuspension.failureTitle'),
          text: I18n.t('Dashboard.Unsuspension.failureText'),
        },
        IN_PROGRESS: {
          title: I18n.t('Dashboard.Unsuspension.inProgressTitle'),
        },
      },
    },
  },
});

export const swapSim = (subscription: ?Subscription): ManageLineActionType => ({
  type: 'SWAP_SIM',
  payload: {
    subscription,
    errorMapForOrderState: {
      key: 'suspendSwapTerminateLine',
      type: {
        FAILED: {
          title: I18n.t('SignUp.SwapSim.failureTitle'),
          text: I18n.t('SignUp.SwapSim.failureText'),
        },
        IN_PROGRESS: {
          title: I18n.t('SignUp.SwapSim.inProgressTitle'),
        },
      },
    },
  },
});
